<template>
  <div class="rank">
    <span>{{ text }}</span>
    <span
      :class="{
        'rank-1': rank === 1,
        'rank-2': rank === 2,
        'rank-3': rank === 3,
        'rank-other': rank > 3,
      }"
    >
      No.{{ rank }}
    </span>
    <img
      v-if="rank === 1"
      class="rank-icon"
      :src="rank1"
    >
    <img
      v-if="rank === 2"
      class="rank-icon"
      :src="rank2"
    >
    <img
      v-if="rank === 3"
      class="rank-icon"
      :src="rank3"
    >
  </div>
</template>

<script>
import rank1 from '@/assets/image/direct/rank-1.png';
import rank2 from '@/assets/image/direct/rank-2.png';
import rank3 from '@/assets/image/direct/rank-3.png';

export default {
  props: {
    rank: {
      type: Number,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      rank1,
      rank2,
      rank3,
    };
  },
};
</script>

<style lang="less" scoped>
.rank {
  color: #9ca6c0;
  font-size: 12px;
  display: flex;
  align-items: center;

  &-icon {
    width: 21px;
    height: 15px;
    margin-left: 12px;
  }

  &-1 {
    color: #ffbd3d;
  }

  &-2 {
    color: #9ca6c0;
  }

  &-3 {
    color: #c79b7d;
  }

  &-other {
    color: @crm-primary-color;
  }
}
</style>